import { useAuth } from "../../../../../../shared/context/auth";
import { useInitiatePurchaseTicket } from "../../dataloader";
import React from "react";
import { TicketPurchaseFormArgsType } from "./type";
import TicketStatus from "../../../../../../shared/enums/TicketStatus";

export default function useTicketPurchaseFormService({ state, onSuccessHandler }: TicketPurchaseFormArgsType) {
  const auth = useAuth();
  const { mutateAsync: initiateRegistration } = useInitiatePurchaseTicket();
  const formRef = React.useRef<any>();

  const isFormDisabled = React.useMemo(() => {
    return (
      state.participantData?.registrationForm.applicationFlow &&
      state.participantData.ticketStatus === TicketStatus.APPLICATION_FLOW_PAYMENT_PENDING
    );
  }, [state.participantData]);

  const isApplicationFlow = React.useMemo(() => {
    return state.participantData?.registrationForm.applicationFlow;
  }, [state.participantData?.registrationForm.applicationFlow]);

  const submitHandler = React.useCallback(
    async formValues => {
      const apiReqObj = {
        registrationParticipantId: auth.userDetail?.id,
        registrationFormId: state.participantData?.registrationForm?.id,
        couponCode: state.couponCodeFormValues?.couponCode,
        ...formValues
      };
      const data = await initiateRegistration(apiReqObj);
      onSuccessHandler?.(data);
    },
    [
      auth.userDetail?.id,
      state.participantData?.registrationForm?.id,
      state.couponCodeFormValues?.couponCode,
      initiateRegistration,
      onSuccessHandler
    ]
  );

  return {
    formRef,
    submitHandler,
    isFormDisabled,
    isApplicationFlow
  };
}
